import {VERSAO_BUILD, temAtualizacao, versaoServidorAtual, consultarVersaoServidor, atualizarAplicativo, avisoTentativaAtualizacao} from './components/atualizacaoApp';
import React, { useEffect, useState } from "react";

export default function Footer() {
  const [showUpdate, setShowUpdate] = useState(false);
  const [version, setVersion] = useState('');
  const [updating, setUpdating] = useState(false);
  const [erroAtualizacao, setErroAtualizacao] = useState('');

  useEffect(() => {
    let ativo = true;
    const checar = () => {
      if (!ativo) return;
      setVersion(versaoServidorAtual());
      setShowUpdate(temAtualizacao());
      setErroAtualizacao(avisoTentativaAtualizacao());
    };
    const consultar = () => { consultarVersaoServidor().then(checar).catch(() => {}); };
    const visivel = () => { if (document.visibilityState === 'visible') consultar(); };
    checar(); consultar();
    const timer = setInterval(visivel, 60000);
    document.addEventListener('visibilitychange', visivel);
    window.addEventListener('focus', consultar);
    window.addEventListener('youapp:version', checar);
    return () => {
      ativo = false; clearInterval(timer);
      document.removeEventListener('visibilitychange', visivel);
      window.removeEventListener('focus', consultar);
      window.removeEventListener('youapp:version', checar);
    };
  }, []);

  const hardReload = async () => {
    if (updating) return;
    setUpdating(true); setErroAtualizacao('');
    try { if (!await atualizarAplicativo()) setUpdating(false); }
    catch (_) { setErroAtualizacao('Não foi possível atualizar. Tente novamente.'); setUpdating(false); }
  };

  return (
    <div>
      {/* Banner de atualização */}
      {showUpdate && (
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            background: "#ffcc00",
            color: "#000",
            padding: "12px 16px",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: "0 -2px 8px rgba(0,0,0,0.2)",
          }}
        >
          <span>
            <strong>Nova versão disponível</strong> ({version})
            {erroAtualizacao && <small style={{display:"block"}}>{erroAtualizacao}</small>}
          </span>

          <button
            disabled={updating}
            onClick={hardReload}
            style={{
              background: "#000",
              color: "#fff",
              border: "none",
              padding: "8px 14px",
              borderRadius: 4,
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            {updating ? 'Atualizando...' : 'Atualizar agora'}
          </button>
        </div>
      )}

      {/* Footer original */}
      <footer className="main-footer">
        Copyright ©2022 by
        <a
          target="_blank"
          id="a_you"
          rel="noopener noreferrer"
          href="https://youevolution.com.br/desenvolvimento"
        >
          {" "}
          You Evolution{" "}
        </a>
        . Todos os direitos reservados.
        <div className="float-right d-sm-inline-block">
          <b>Versão</b> {VERSAO_BUILD}
        </div>
      </footer>
    </div>
  );
}
